import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { ArrowIconProps } from 'fronton-react';
import { findTopCategoryData } from 'utils';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { selectTopCategories } from 'containers/catalogue/catalogue/selectors';
import { NUMBER_OF_SHOWN_FILTER_ITEMS } from '../../../../../../../constants';
import { useCatalogueContentSlice } from '../../hooks';
import { selectSelectedFilterItems } from '../../selectors';

export const useSideFilter = () => {
	const { changeSelectedFilterItems } = useCatalogueContentSlice();

	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const topCategories = useSelector(selectTopCategories);

	const changeSelectedItems = useCallback(
		(newSelectedItems: number[]) =>
			changeSelectedFilterItems({ changedFilterItems: newSelectedItems, topCategories }),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[changeSelectedFilterItems]
	);

	const elementBlock = 'serviceListFilter';

	const checkboxHandler = (topCategoryId: number) => {
		changeSelectedItems([topCategoryId]);

		const { topCategoryName } = findTopCategoryData(topCategories, topCategoryId);
		GAClickButton({
			elementBlock,
			elementName: 'Список услуг',
			elementText: topCategoryName,
		});
	};

	const showMoreFIBtnTextPattern = `Еще ${topCategories.length - NUMBER_OF_SHOWN_FILTER_ITEMS}`;

	const [isHiddenListOpen, setISHiddenListOpen] = useState(false);
	const [[showMoreFIBtnText, showMoreFIBtnArrowDirection], setShowMoreFIBtn] = useState<
		[string, ArrowIconProps['direction']]
	>([showMoreFIBtnTextPattern, 'bottom']);

	const showMoreFilterItemsBtnHandler = () => {
		setISHiddenListOpen(!isHiddenListOpen);
		setTimeout(() => {
			// use reverse order because state hasn't changed yet
			setShowMoreFIBtn(
				isHiddenListOpen ? [showMoreFIBtnTextPattern, 'bottom'] : ['Свернуть', 'top']
			);
		}, 500);

		GAClickButton({
			elementBlock,
			elementName: `${isHiddenListOpen ? 'close' : 'open'}-detailed`,
			elementText: 'Список услуг',
		});
	};

	return {
		checkboxHandler,
		selectedFilterItems,
		topCategories,
		isHiddenListOpen,
		showMoreFIBtnText,
		showMoreFIBtnArrowDirection,
		showMoreFilterItemsBtnHandler,
	};
};
